<template>
	<div>
		<div class="tw-text-3xl tw-font-bold">
			{{ $t('integrations.select-shopify-location-title') }}
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.select-shopify-location-description') }}
		</div>
		<div class="tw-mt-4 tw-grid tw-grid-cols-2 tw-gap-3">
			<AppSelect v-model="selected" :options="options" optionLabel="name" optionValue="id" />
		</div>
		<div class="tw-mt-5">
			<AppButton :label="$t('integrations.confirm')" size="xl" class="tw-rounded-full" :disabled="loading || !selected" @click="save" />
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { api } from '@/v2/plugins/axios';
import { Alert } from '@/v2/plugins/alert';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const linkMarketplaceStore = useLinkMarketplaceStore();
const options = ref([]);
const selected = ref(null);
const loading = ref(false);

onMounted(async () => {
	const id = linkMarketplaceStore.linkedMarketplaceId;
	const res = await api.get(`/v1/marketplaces/${id}/shopify/locations`);
	options.value = (res.data.result.locations || []).map((l) => ({ id: l.id, name: l.name }));
	if (options.value.length === 1) {
		selected.value = options.value[0].id;
	}
});

const save = async () => {
	loading.value = true;
	try {
		const id = linkMarketplaceStore.linkedMarketplaceId;
		await api.post(`/v1/marketplaces/${id}/shopify/locations/default`, { location_id: selected.value });
        Alert.success(t('integrations.location-saved-successfully'));
        // mark step as finished then refetch
        await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
        await linkMarketplaceStore.refetchSteps();
	} finally {
		loading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>


